import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';
import { toFormikArray } from '../components/molecules/ArrayTextInput';
import { ContactInfo } from '../generated/graphql';

export const toInitialContactInfo = <T extends Maybe<ContactInfo>>(contactInfo: T) => ({
    emails: toFormikArray(contactInfo?.emails),
    phoneNumbers: toFormikArray(contactInfo?.phoneNumbers),
    contactName: contactInfo?.contactName ?? '',
});
